import LanguageSwitcher from './languageSwitcher';

export default LanguageSwitcher;
